// Age group validation -- iteration 053 (lookup table, no CRUD)
// Create/update schemas removed -- age groups are seed-only lookup data.

/**
 * Compute eligible birth year range (inclusive).
 *
 * Eligibility = "birth year, not current age".
 *   U{N} → born in currentYear - N  (single year for normal groups)
 *   Open U{N} → spans multiple birth years via different offsets
 *
 * year_offset_min / year_offset_max:
 *   - U14 (both = 14): born 2026 - 14 = 2012. Single year.
 *   - Open U13 (min=12, max=13): born 2026-13=2013 to 2026-12=2014.
 *
 * Returns inclusive {min, max} birth years.
 *   DB queries: gte ${min}-01-01, lte ${max}-12-31
 *   JS checks:  birthYear >= min && birthYear <= max
 */
export function birthYearRange(ageGroup: {
  year_offset_min: number;
  year_offset_max: number;
}): { min: number; max: number } {
  const currentYear = new Date().getFullYear();
  return {
    min: currentYear - ageGroup.year_offset_max,
    max: currentYear - ageGroup.year_offset_min,
  };
}

/** @deprecated Use birthYearRange. */
export function naturalBirthYearRange(ageGroup: {
  year_offset_min: number;
  year_offset_max: number;
}): { min: number; max: number } {
  return birthYearRange(ageGroup);
}
